import React, { ComponentPropsWithoutRef, FC } from 'react';

import { useTheme } from '@mui/material';
import { motion } from 'framer-motion';

import { Svg } from '~/assets/icons/styles';

const CloseInCircleAnimatedIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => {
  const theme = useTheme();
  return (
    <Svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={theme.palette.common.status.error}
      {...props}
    >
      <motion.ellipse
        cx="15.9974"
        cy="16.0013"
        rx="13.3333"
        ry="13.3333"
        transform="rotate(-45 15.9968 16)"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{
          duration: 0.8,
          ease: 'easeInOut',
        }}
      />
      <motion.path
        d="M10.7734 21.1554L21.2336 10.6953"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ pathLength: 1, pathOffset: 1, x: '10%', y: '-10%' }}
        animate={{ pathLength: 1, pathOffset: 0, x: '0%', y: '0%' }}
        transition={{
          delay: 0.8,
          duration: 0.4,
          ease: 'easeInOut',
        }}
      />
      <motion.path
        d="M21.2336 21.1554L10.7734 10.6953"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ visibility: 'hidden', pathLength: 1, pathOffset: 1, x: '15%', y: '15%' }}
        animate={{ visibility: 'visible', pathLength: 1, pathOffset: 0, x: '0%', y: '0%' }}
        transition={{
          delay: 0.8,
          duration: 0.4,
          ease: 'easeInOut',
        }}
      />
    </Svg>
  );
};

export default CloseInCircleAnimatedIcon;
